import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe } from '@angular/common';
export class ServicesVisitIn {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    console.log("门店信息");
    if (webcontext.ConfigType.toLowerCase() == "form") {
      console.log(webcontext.RequestBody);
      let request = JSON.parse(webcontext.RequestBody);
      webcontext.OpType = "Edite";
      const _visitStoreInfo = JSON.parse(localStorage.getItem("visitStoreInfo"));
      request["a_ID"] = webcontext.ID;
      if(_visitStoreInfo["id"]){
        request["a_ID"] = _visitStoreInfo["id"];
      }
      let datepie: DatePipe = new DatePipe("en-US");
      request.a_startDate = datepie.transform(new Date(), "yyyy-MM-dd HH:mm:ss");
      request.a_FK_TBVisitState_ID = "S002";//拜访中
      webcontext.SpecialParameter = "gohome";//进店
      if (request.DeviationNumber) {
        request.a_InDeviationNumber = request.DeviationNumber;//上班与门店的偏差值
        delete request.DeviationNumber;
      }
      // if (typeof (request.a_StartAddress) == "undefined" && (typeof(request.a_StartRemark)=="undefined" || request.a_StartRemark.toString().trim()=="")) {
      //     webcontext.ResponseMessage.ErrorMessage = "请填写备注";
      //      webcontext.ResponseMessage.Success = false;
      // }
      // else 
      if (typeof (request.a_StartPhoto) == "undefined") {
          webcontext.ResponseMessage.ErrorMessage = "必须拍摄门头照";
          webcontext.ResponseMessage.Success = false;
        }else if(request.a_StartPhoto.toString().trim() == ""){
          webcontext.ResponseMessage.ErrorMessage = "必须拍摄门头照";
          webcontext.ResponseMessage.Success = false;
        }
      //  consle.log(t);
      // let repone ={"a_AuditStatus":"0","CHILDOBJ_TypeOfLeaveSysUserXML":{"Datas":[{"a_FK_SystemUser_ID":"7aed9ea2-3afa-4059-b3f4-9698be2ba9ba"},{"a_FK_SystemUser_ID":"7aed9ea2-3afa-4059-b3f4-9698be2ba9ba"}],"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"}},"a_StartDate":"2019-03-11 23:59:59","a_EndDate":"2019-03-13 23:59:59","a_LeaveLength":"10","a_Remarks":"sadfasdasdasd"};
      webcontext.RequestBody = JSON.stringify(request);
    }

    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
    const that = this;
    if (webParameterContext.ConfigType.toLowerCase() == "form") {
      if (webContext.ResponseMessage.Success) {
        let datepie: DatePipe = new DatePipe("en-US");
        if (webContext.Other) {
          webContext.Other.Success = true;
          webContext.url = "/tabs/contact/VisitPlatform/add/" + webParameterContext.ID;
        } else {
          webContext.Other = { "Success": true, "url": "/tabs/contact/VisitPlatform/add/" + webParameterContext.ID };
        }
      }
    }

    return webContext
  }
}